import React from 'react';
import {
  IonList,
  IonItem,
  IonRadioGroup,
  IonRadio,
  IonLabel,
  IonNote,
  IonButtons,
  IonButton,
  IonAlert,
  IonText,
  IonIcon,
} from '@ionic/react';
import Loading from '../../components/spinner';
import Layout from '../../components/layout';
import {
  Title,
  Sectiontitle,
  SmallText,
  Spacer,
  NormalText,
  StrongText,
} from '../../components/common';
import { withTranslation } from '../../lib/translate';
import { updateProfile, removePaymentCard } from '../../store/actions';
import { connect } from 'react-redux';
import { isDefined, forwardTo, goBack, isWebConfig } from '../../lib/utils';
import { getConfig } from '../../appConfig';
import './index.css';
import { cardOutline, pencil, removeCircleOutline, trashBin, trashBinOutline } from 'ionicons/icons';

class Cards extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      removeCardAlert: null,
      selectPaymentCard: this.props.profile.cardToken || null,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.profile.cardToken !== this.props.profile.cardToken) {
      this.setState({ selectPaymentCard: this.props.profile.cardToken });
    }
  }

  changeDefaultPaymentCard = (event) =>
    this.setState({ selectPaymentCard: event.detail.value }, () => {
      this.props.dispatch(updateProfile({ cardToken: event.detail.value }, true));
    });

  removePaymentCard = () => {
    const { __ } = this.props;
    this.props.dispatch(
      removePaymentCard(this.state.removeCardAlert, {
        __,
        cb: () => this.setState({ removeCardAlert: null }),
      }),
    );
  };

  handleRemoveCardAlert = (cardId) => this.setState({ removeCardAlert: cardId });

  backHandler = () => {
    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.addCardFromAccount
    ) {
      forwardTo('/account', { addCardFromAccount: true });
    } else {
      goBack();
    }
  };

  render() {
    const { __, cards } = this.props;
    const { removeCardAlert } = this.state;

    return (
      <Loading transparent>
        <Layout
          showHeader
          showBack
          hideSecondToolbar={true}
          color="transparent"
          headerTitle={__('Your Credit Cards')}
          backHandler={this.backHandler}
          headerWithTitle={true}
        >
          <div className="flex-row-wrapper absolute-content">
            <div className="scrollable-y">
              <Title className="web-only uppercase">{__('Your Credit Cards')}</Title>
              <IonList  lines="none">

                <IonRadioGroup
                  onIonChange={this.changeDefaultPaymentCard}
                  value={this.state.selectPaymentCard}
                >
                  {cards.length > 0 &&
                    cards.map((card) => {
                      const { id, last4, brand, exp_month, exp_year, name } = card;
                      return (
                        <IonItem lines="none" className="box-content checkout-card " key={id}>
                          <IonIcon slot="start" icon={cardOutline}></IonIcon>

                          <IonLabel className="ion-text-wrap">
                            <StrongText className="dark-color block">**** **** **** {last4.substr(-4)}</StrongText>
                            <SmallText className='secondary-font'>
                              {__(brand)} - {exp_month}/{exp_year}
                            </SmallText>
                          </IonLabel>
                       
                          {!getConfig().flags.removeCardHidden &&
                            <IonButton onClick={() => this.handleRemoveCardAlert(id)} className="link">
                              <IonIcon icon={removeCircleOutline} />
                            </IonButton>
                          }

                        </IonItem>
                        // <IonItem key={id} className="cards-list-card box-wrapper">
                        //   <div tabIndex="-1"></div>
                        //   <div className="cards-list-card-image">
                        //     <IonIcon color="red" icon={cardOutline}></IonIcon>
                        //   </div>
                        //   <IonLabel className="ion-text-wrap card-wrapper">
                        //     <NormalText className="single-item" color="primary">
                        //       {name}
                        //     </NormalText>
                        //     <StrongText className="single-item" color="primary">
                        //       •••• •••• •••• {last4}
                        //     </StrongText>
                        //     <SmallText color="primary">
                        //       {__(brand)} - {exp_month}/{exp_year}
                        //     </SmallText>
                        //   </IonLabel>

                        //   <SmallText color="primary">
                        //     <IonButton
                        //       onClick={() => this.handleRemoveCardAlert(id)}
                        //       expand="block"
                        //       fill="clear"
                        //       color="secondary"
                        //       className=" underlined"
                        //     >
                        //       <IonIcon color="primary" icon={trashBinOutline} />
                        //     </IonButton>
                        //   </SmallText>
                        // </IonItem>
                      );
                    })}
                </IonRadioGroup>
              </IonList>
              <IonButton
                expand="block"
                className=" underlined link"
                onClick={() =>
                  forwardTo('/card-add', {
                    addCardFromAccount:true,
                    ...(this.props.location && this.props.location.state
                      ? this.props.location.state
                      : {}),
                  })
                }
              >
                {__('Add new payment card')}
              </IonButton>
            </div>
            <div className="flex-min">
              {/* <IonButton onClick={ () => forwardTo('/account', { ...this.props.location && this.props.location.state ? this.props.location.state : {}}) } expand="block" color="secondary">{ __('Done') }</IonButton> */}
              {/* <IonButton
                expand="block"
                color="secondary"
                onClick={() =>
                  forwardTo('/card-add', {
                    ...(this.props.location && this.props.location.state
                      ? this.props.location.state
                      : {}),
                  })
                }
              >
                {__('Add Payment Card')}
              </IonButton> */}
            </div>
          </div>
        </Layout>
        <IonAlert
          isOpen={isDefined(removeCardAlert)}
          onDidDismiss={() => this.handleRemoveCardAlert(null)}
          header={__('Confirm')}
          message={__('Do you you want to remove this card?')}
          buttons={[
            {
              text: __('Cancel'),
              role: 'cancel',
              cssClass: 'secondary',
            },
            {
              text: __('Remove'),
              handler: () => this.removePaymentCard(),
            },
          ]}
        />
      </Loading>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    cards: store.orders.cards || [],
    profile: store.profile.profile || {},
  };
};

export default connect(mapStateToProps)(withTranslation(Cards));
